import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { Gallery } from '../components/Gallery';
import { ArtistStatement } from '../components/ArtistStatement';
import { About } from '../components/About';
import { Footer } from '../components/Footer';
export function Home() {
  return <main className="min-h-screen bg-offwhite" data-id="element-248">
      <Navbar data-id="element-249" />
      <Hero data-id="element-250" />
      <Gallery data-id="element-251" />
      <ArtistStatement data-id="element-252" />
      <About data-id="element-253" />
      <Footer data-id="element-254" />
    </main>;
}